<template>
  <div>
    <list
      row-key="TeacherId"
      ref="list"
      unit="教职员工信息"
      :page="page"
      :query-params="params"
      :show-checkbox="showCheckbox"
      :show-query="showQuery"
      :get-data-func="api.list"
    >
      <template slot="query">
        <el-form-item label="教职工编号" class="longLabel">
          <el-input v-model="params.TeacherNumber" placeholder="请填写教职工编号" />
        </el-form-item>
        <el-form-item label="姓名">
          <el-input v-model="params.TeacherName" placeholder="请填写姓名" />
        </el-form-item>
      </template>
      <template slot="table">
        <el-table-column prop="TeacherNumber" label="教职工编号" min-width="100" />
        <el-table-column prop="TeacherName" label="姓名" />
        <el-table-column label="性别" min-width="50">
          <template slot-scope="{row}">
            <span v-if="row.Sex==0">无</span>
            <span v-if="row.Sex==1">男</span>
            <span v-if="row.Sex==2">女</span>
          </template>
        </el-table-column>
        <el-table-column prop="Status" label="状态" min-width="70">
          <template slot-scope="{row}">
            <span v-if="row.Status==0">教师在岗</span>
            <span v-if="row.Status==2">教辅在岗</span>
            <span v-if="row.Status==3">其他</span>
            <span v-if="row.Status==1">离退</span>
          </template>
        </el-table-column>
        <slot name="column"></slot>
      </template>
    </list>
  </div>
</template>
<script>
import listMixin from "@/mixins/list";
import list from "@/components/common/list";

export default {
  mixins: [listMixin],
  components: { list },
  props: {},
  computed: {},
  mounted() {},
  data() {
    return {
      api: require("@/api/fa/teacher").default,
      params: {
        TeacherNumber: "",
        TeacherName: "",
        JobNames: "",
        Title: "",
        InYears: null,
        Statuses: [0, 2, 3],
      },
      isMB: this.$store.state.isMB,
    };
  },
  methods: {},
};
</script>
<style lang="scss">
</style>